// src/products/equityManager/utils/numberFormatter.js
// Utility function to format numbers with K (thousands) or M (millions) suffixes

export const formatNumberWithUnits = (num) => {
  if (num === null || num === undefined) return '0';
  const numValue = typeof num === 'string' ? parseFloat(num) : num;
  if (isNaN(numValue)) return '0';
  
  const absNum = Math.abs(numValue);
  
  // For numbers >= 1 million, use M (millions)
  if (absNum >= 1000000) {
    const millions = numValue / 1000000;
    // Show 1 decimal place if less than 10M, otherwise no decimals
    if (absNum < 10000000) {
      return `${millions.toFixed(1)}M`;
    }
    return `${Math.round(millions)}M`;
  }
  
  // For numbers >= 1 thousand, use K (thousands)
  if (absNum >= 1000) {
    const thousands = numValue / 1000;
    // Show 1 decimal place if less than 10K, otherwise no decimals
    if (absNum < 10000) {
      return `${thousands.toFixed(1)}K`;
    }
    return `${Math.round(thousands)}K`;
  }
  
  // For numbers < 1000, show full number with commas
  return new Intl.NumberFormat('en-US').format(num);
};

export default formatNumberWithUnits;
